import { ReactElement, useEffect, useState } from 'react';
import { StyledBackToButton } from './BackToButton.styles';
import ChevronBackSVG from './assets/chevron-back.svg';
import { useTheme } from 'styled-components';
import { isBicentenary, isZsl } from '@/lib/utils';
import { HubSettings } from '@/components/organisms/Header';

export default function BackToButton({ hubSettings }: { hubSettings?: HubSettings }): ReactElement {
  const { key } = useTheme();
  const [previousUrl, setPreviousUrl] = useState<string | null>(null);
  const [showBackButton, setShowBackButton] = useState(false);

  useEffect(() => {
    try {
      const getPreviousReferrerUrl = () => {
        const referrer = document.referrer;
        if (referrer) {
          const referrerDomain = new URL(referrer).origin;
          const currentDomain = window.location.origin;

          const isOnZslFromBicentenary = () => {
            // Check if referrer contains '/200' (or as defined in admin) followed by nothing, '/', or any path
            const pattern = "\/" + (hubSettings?.hubPrefix ?? '200') + "(?:\/.*)?$";
            const bicentenaryPattern = new RegExp(`${pattern}`);
            return referrerDomain === currentDomain && bicentenaryPattern.test(referrer);
          };

          if (isZsl(key)) {
            if (isOnZslFromBicentenary()) {
              return referrer;
            }
          }
        }
        return null;
      }

      const referrer = getPreviousReferrerUrl();
      setShowBackButton(!!(referrer || isBicentenary(key)));
      setPreviousUrl(referrer);
    } catch (error) {
    }
  }, []);

  const handleBackClickOnZslMainSite = () => {
    try {
      if (previousUrl) {
        window.location.href = previousUrl;
      }
    } catch (error) {
      window.history.back();
    }
    window.history.back();
  };

  if (showBackButton) {
    if (isBicentenary(key)) {
      return (
        <StyledBackToButton as="a" href={window.location.origin}>
          <ChevronBackSVG />
          <span>{hubSettings?.toMainLabel ?? 'TO ZSL MAIN SITE'}</span>
        </StyledBackToButton>
      );
    } else {
      return (
        <StyledBackToButton as="button" onClick={handleBackClickOnZslMainSite}>
          <ChevronBackSVG />
          <span>{hubSettings?.toHubLabel ?? "BACK TO ZSL'S 200TH"}</span>
        </StyledBackToButton>
      );
    }
  }

  return <></>;
}
